export const ZODIAC_SIGNS_CN = {
  Aries: {
    title: '白羊座',
    time: [
      [3, 21],
      [4, 19],
    ],
  },
  Taurus: {
    title: '金牛座',
    time: [
      [4, 20],
      [5, 20],
    ],
  },
  Gemini: {
    title: '双子座',
    time: [
      [5, 21],
      [6, 21],
    ],
  },
  Cancer: {
    title: '巨蟹座',
    time: [
      [6, 22],
      [7, 22],
    ],
  },
  Leo: {
    title: '狮子座',
    time: [
      [7, 23],
      [8, 22],
    ],
  },
  Virgo: {
    title: '处女座',
    time: [
      [8, 23],
      [9, 22],
    ],
  },
  Libra: {
    title: '天秤座',
    time: [
      [9, 23],
      [10, 23],
    ],
  },
  Scorpio: {
    title: '天蝎座',
    time: [
      [10, 24],
      [11, 22],
    ],
  },
  Sagittarius: {
    title: '射手座',
    time: [
      [11, 23],
      [12, 21],
    ],
  },
  Capricorn: {
    title: '摩羯座',
    time: [
      [12, 22],
      [1, 19],
    ],
  },
  Aquarius: {
    title: '水瓶座',
    time: [
      [1, 20],
      [2, 18],
    ],
  },
  Pisces: {
    title: '双鱼座',
    time: [
      [2, 19],
      [3, 20],
    ],
  },
}

export const CONSTELLATION_ARRAY = [
  { id: 1, name: '白羊座', en: 'aries' },
  { id: 2, name: '金牛座', en: 'taurus' },
  { id: 3, name: '双子座', en: 'gemini' },
  { id: 4, name: '巨蟹座', en: 'cancer' },
  { id: 5, name: '狮子座', en: 'leo' },
  { id: 6, name: '处女座', en: 'virgo' },
  { id: 7, name: '天秤座', en: 'libra' },
  { id: 8, name: '天蝎座', en: 'scorpio' },
  { id: 9, name: '射手座', en: 'sagittarius' },
  { id: 10, name: '摩羯座', en: 'capricorn' },
  { id: 11, name: '水瓶座', en: 'aquarius' },
  { id: 12, name: '双鱼座', en: 'pisces' },
]

export const RoomLink = 'hifun://page/chatroom?roomId='

export const MessageLink = 'hifun://page/private_chat?userid='

export const DEFAULT_FEMALE_AVATARS = [
  'https://cdn.hifunclub.com/girl_avatar/1.png',
  'https://cdn.hifunclub.com/girl_avatar/2.png',
  'https://cdn.hifunclub.com/girl_avatar/3.png',
  'https://cdn.hifunclub.com/girl_avatar/4.png',
  'https://cdn.hifunclub.com/girl_avatar/5.png',
  'https://cdn.hifunclub.com/girl_avatar/6.png',
  'https://cdn.hifunclub.com/girl_avatar/7.png',
  'https://cdn.hifunclub.com/girl_avatar/8.png',
  'https://cdn.hifunclub.com/girl_avatar/9.png',
  'https://cdn.hifunclub.com/girl_avatar/10.png',
  'https://cdn.hifunclub.com/girl_avatar/11.png',
  'https://cdn.hifunclub.com/girl_avatar/12.png',
  'https://cdn.hifunclub.com/girl_avatar/13.png',
  'https://cdn.hifunclub.com/girl_avatar/14.png',
  'https://cdn.hifunclub.com/girl_avatar/15.png',
  'https://cdn.hifunclub.com/girl_avatar/16.png',
  'https://cdn.hifunclub.com/girl_avatar/17.png',
  'https://cdn.hifunclub.com/girl_avatar/18.png',
  'https://cdn.hifunclub.com/girl_avatar/19.png',
  'https://cdn.hifunclub.com/girl_avatar/20.png',
  'https://cdn.hifunclub.com/girl_avatar/21.png',
  'https://cdn.hifunclub.com/girl_avatar/22.png',
  'https://cdn.hifunclub.com/girl_avatar/23.png',
  'https://cdn.hifunclub.com/girl_avatar/24.png',
  'https://cdn.hifunclub.com/girl_avatar/25.png',
  'https://cdn.hifunclub.com/girl_avatar/26.png',
  'https://cdn.hifunclub.com/girl_avatar/27.png',
  'https://cdn.hifunclub.com/girl_avatar/28.png',
  'https://cdn.hifunclub.com/girl_avatar/29.png',
  'https://cdn.hifunclub.com/girl_avatar/30.png',
  'https://cdn.hifunclub.com/girl_avatar/31.png',
  'https://cdn.hifunclub.com/girl_avatar/32.png',
  'https://cdn.hifunclub.com/girl_avatar/33.png',
  'https://cdn.hifunclub.com/girl_avatar/34.png',
  'https://cdn.hifunclub.com/girl_avatar/35.png',
  'https://cdn.hifunclub.com/girl_avatar/36.png',
  'https://cdn.hifunclub.com/girl_avatar/37.png',
  'https://cdn.hifunclub.com/girl_avatar/38.png',
  'https://cdn.hifunclub.com/girl_avatar/39.png',
  'https://cdn.hifunclub.com/girl_avatar/40.png',
  'https://cdn.hifunclub.com/girl_avatar/41.png',
  'https://cdn.hifunclub.com/girl_avatar/42.png',
  'https://cdn.hifunclub.com/girl_avatar/43.png',
  'https://cdn.hifunclub.com/girl_avatar/44.png',
  'https://cdn.hifunclub.com/girl_avatar/45.png',
  'https://cdn.hifunclub.com/girl_avatar/46.png',
  'https://cdn.hifunclub.com/girl_avatar/47.png',
  'https://cdn.hifunclub.com/girl_avatar/48.png',
  'https://cdn.hifunclub.com/girl_avatar/49.png',
  'https://cdn.hifunclub.com/girl_avatar/50.png',
]

export const DEFAULT_MALE_AVATARS = [
  'https://cdn.hifunclub.com/boy_avatar/1.png',
  'https://cdn.hifunclub.com/boy_avatar/2.png',
  'https://cdn.hifunclub.com/boy_avatar/3.png',
  'https://cdn.hifunclub.com/boy_avatar/4.png',
  'https://cdn.hifunclub.com/boy_avatar/5.png',
  'https://cdn.hifunclub.com/boy_avatar/6.png',
  'https://cdn.hifunclub.com/boy_avatar/7.png',
  'https://cdn.hifunclub.com/boy_avatar/8.png',
  'https://cdn.hifunclub.com/boy_avatar/9.png',
  'https://cdn.hifunclub.com/boy_avatar/10.png',
  'https://cdn.hifunclub.com/boy_avatar/11.png',
  'https://cdn.hifunclub.com/boy_avatar/12.png',
  'https://cdn.hifunclub.com/boy_avatar/13.png',
  'https://cdn.hifunclub.com/boy_avatar/14.png',
  'https://cdn.hifunclub.com/boy_avatar/15.png',
  'https://cdn.hifunclub.com/boy_avatar/16.png',
  'https://cdn.hifunclub.com/boy_avatar/17.png',
  'https://cdn.hifunclub.com/boy_avatar/18.png',
  'https://cdn.hifunclub.com/boy_avatar/19.png',
  'https://cdn.hifunclub.com/boy_avatar/20.png',
  'https://cdn.hifunclub.com/boy_avatar/21.png',
  'https://cdn.hifunclub.com/boy_avatar/22.png',
  'https://cdn.hifunclub.com/boy_avatar/23.png',
  'https://cdn.hifunclub.com/boy_avatar/24.png',
  'https://cdn.hifunclub.com/boy_avatar/25.png',
  'https://cdn.hifunclub.com/boy_avatar/26.png',
  'https://cdn.hifunclub.com/boy_avatar/27.png',
  'https://cdn.hifunclub.com/boy_avatar/28.png',
  'https://cdn.hifunclub.com/boy_avatar/29.png',
  'https://cdn.hifunclub.com/boy_avatar/30.png',
  'https://cdn.hifunclub.com/boy_avatar/31.png',
  'https://cdn.hifunclub.com/boy_avatar/32.png',
  'https://cdn.hifunclub.com/boy_avatar/33.png',
  'https://cdn.hifunclub.com/boy_avatar/34.png',
  'https://cdn.hifunclub.com/boy_avatar/35.png',
  'https://cdn.hifunclub.com/boy_avatar/36.png',
  'https://cdn.hifunclub.com/boy_avatar/37.png',
  'https://cdn.hifunclub.com/boy_avatar/38.png',
  'https://cdn.hifunclub.com/boy_avatar/39.png',
  'https://cdn.hifunclub.com/boy_avatar/40.png',
  'https://cdn.hifunclub.com/boy_avatar/41.png',
  'https://cdn.hifunclub.com/boy_avatar/42.png',
  'https://cdn.hifunclub.com/boy_avatar/43.png',
  'https://cdn.hifunclub.com/boy_avatar/44.png',
  'https://cdn.hifunclub.com/boy_avatar/45.png',
  'https://cdn.hifunclub.com/boy_avatar/46.png',
  'https://cdn.hifunclub.com/boy_avatar/47.png',
  'https://cdn.hifunclub.com/boy_avatar/48.png',
  'https://cdn.hifunclub.com/boy_avatar/49.png',
  'https://cdn.hifunclub.com/boy_avatar/50.png',
  'https://cdn.hifunclub.com/boy_avatar/51.png',
  'https://cdn.hifunclub.com/boy_avatar/52.png',
  'https://cdn.hifunclub.com/boy_avatar/53.png',
  'https://cdn.hifunclub.com/boy_avatar/54.png',
  'https://cdn.hifunclub.com/boy_avatar/55.png',
  'https://cdn.hifunclub.com/boy_avatar/56.png',
  'https://cdn.hifunclub.com/boy_avatar/57.png',
  'https://cdn.hifunclub.com/boy_avatar/58.png',
  'https://cdn.hifunclub.com/boy_avatar/59.png',
  'https://cdn.hifunclub.com/boy_avatar/60.png',
  'https://cdn.hifunclub.com/boy_avatar/61.png',
  'https://cdn.hifunclub.com/boy_avatar/62.png',
  'https://cdn.hifunclub.com/boy_avatar/63.png',
  'https://cdn.hifunclub.com/boy_avatar/64.png',
  'https://cdn.hifunclub.com/boy_avatar/65.png',
  'https://cdn.hifunclub.com/boy_avatar/66.png',
  'https://cdn.hifunclub.com/boy_avatar/67.png',
  'https://cdn.hifunclub.com/boy_avatar/68.png',
  'https://cdn.hifunclub.com/boy_avatar/69.png',
  'https://cdn.hifunclub.com/boy_avatar/70.png',
  'https://cdn.hifunclub.com/boy_avatar/71.png',
  'https://cdn.hifunclub.com/boy_avatar/72.png',
  'https://cdn.hifunclub.com/boy_avatar/73.png',
  'https://cdn.hifunclub.com/boy_avatar/74.png',
  'https://cdn.hifunclub.com/boy_avatar/75.png',
  'https://cdn.hifunclub.com/boy_avatar/76.png',
  'https://cdn.hifunclub.com/boy_avatar/77.png',
  'https://cdn.hifunclub.com/boy_avatar/78.png',
  'https://cdn.hifunclub.com/boy_avatar/79.png',
  'https://cdn.hifunclub.com/boy_avatar/80.png',
  'https://cdn.hifunclub.com/boy_avatar/81.png',
  'https://cdn.hifunclub.com/boy_avatar/82.png',
  'https://cdn.hifunclub.com/boy_avatar/83.png',
  'https://cdn.hifunclub.com/boy_avatar/84.png',
  'https://cdn.hifunclub.com/boy_avatar/85.png',
  'https://cdn.hifunclub.com/boy_avatar/86.png',
  'https://cdn.hifunclub.com/boy_avatar/87.png',
  'https://cdn.hifunclub.com/boy_avatar/88.png',
  'https://cdn.hifunclub.com/boy_avatar/89.png',
  'https://cdn.hifunclub.com/boy_avatar/90.png',
  'https://cdn.hifunclub.com/boy_avatar/91.png',
  'https://cdn.hifunclub.com/boy_avatar/92.png',
  'https://cdn.hifunclub.com/boy_avatar/93.png',
  'https://cdn.hifunclub.com/boy_avatar/94.png',
  'https://cdn.hifunclub.com/boy_avatar/95.png',
  'https://cdn.hifunclub.com/boy_avatar/96.png',
  'https://cdn.hifunclub.com/boy_avatar/97.png',
  'https://cdn.hifunclub.com/boy_avatar/98.png',
  'https://cdn.hifunclub.com/boy_avatar/99.png',
]
